"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SecondaryActionButton = exports.PrimaryActionButton = exports.Description = exports.SubTitle = exports.BlankSlate = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Button_1 = require("../../components/Button");
require("./BlankSlate.css");
var classnames_1 = __importDefault(require("classnames"));
var BlankSlate = function (_a) {
  var children = _a.children,
    alignment = _a.alignment,
    _b = _a.title,
    title = _b === void 0 ? "You do not have any content." : _b,
    _c = _a.headerGraphic,
    headerGraphic = _c === void 0 ? "" : _c,
    _d = _a.className,
    className = _d === void 0 ? "" : _d,
    restProps = __rest(_a, ["children", "alignment", "title", "headerGraphic", "className"]);
  return (0, jsx_runtime_1.jsxs)("div", __assign({}, restProps, {
    className: (0, classnames_1.default)("vsx-bs-container", alignment === "left-side" && "vsx-bs-leftalign", className)
  }, {
    children: [(0, jsx_runtime_1.jsx)("div", __assign({
      className: "vsx-bs-img"
    }, {
      children: headerGraphic
    })), (0, jsx_runtime_1.jsxs)("div", __assign({
      className: "vsx-bs-content"
    }, {
      children: [(0, jsx_runtime_1.jsx)("h1", __assign({
        className: "vsx-bs-title"
      }, {
        children: title
      })), children]
    }))]
  }));
};
exports.BlankSlate = BlankSlate;
var SubTitle = function (_a) {
  var className = _a.className,
    children = _a.children;
  return (0, jsx_runtime_1.jsx)("div", __assign({
    className: (0, classnames_1.default)("vsx-bs-subtitle", className)
  }, {
    children: children
  }));
};
exports.SubTitle = SubTitle;
var Description = function (_a) {
  var className = _a.className,
    children = _a.children;
  return (0, jsx_runtime_1.jsx)("p", __assign({
    className: (0, classnames_1.default)("vsx-bs-description-text", className)
  }, {
    children: children
  }));
};
exports.Description = Description;
var PrimaryActionButton = function (_a) {
  var label = _a.label,
    _b = _a.handler,
    handler = _b === void 0 ? function () {} : _b,
    _c = _a.className,
    className = _c === void 0 ? "" : _c,
    restProps = __rest(_a, ["label", "handler", "className"]);
  return (0, jsx_runtime_1.jsx)("div", {
    children: (0, jsx_runtime_1.jsx)(Button_1.Button, __assign({}, restProps, {
      type: "primary",
      className: "vsx-bs-button-primary ".concat(className),
      onClick: handler
    }, {
      children: label
    }))
  });
};
exports.PrimaryActionButton = PrimaryActionButton;
var SecondaryActionButton = function (_a) {
  var label = _a.label,
    _b = _a.handler,
    handler = _b === void 0 ? function () {} : _b,
    _c = _a.className,
    className = _c === void 0 ? "" : _c,
    restProps = __rest(_a, ["label", "handler", "className"]);
  return (0, jsx_runtime_1.jsx)("div", {
    children: (0, jsx_runtime_1.jsx)(Button_1.Button, __assign({}, restProps, {
      type: "tertiary",
      className: (0, classnames_1.default)("vsx-bs-button-secondary", className),
      onClick: handler
    }, {
      children: label
    }))
  });
};
exports.SecondaryActionButton = SecondaryActionButton;